import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ShipmentGroupDetailProvider } from '@uturn/portal/modules/shipments/providers/shipment-group-detail';

export const Route = createFileRoute('/_protected/shipments')({
	component: () => (
		<ShipmentGroupDetailProvider>
			<Outlet />
		</ShipmentGroupDetailProvider>
	),
});
